import {
  Button,
  Modal,
  Text,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Spinner,
  ListItem,
  UnorderedList,
  useToast,
} from "@chakra-ui/react";
import { string } from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { deactivateAccount } from "../../../redux/actions/user/UserActions";
import { RootStore } from "../../../redux/Store";

function DeactivateAccountModal(props: any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const uiState = useSelector((state: RootStore) => state.ui);
  const userState = useSelector((state: RootStore) => state.user);
  const toast = useToast();
  const handleDeactivate = () => {
    dispatch(deactivateAccount(history));
  };
  useEffect(() => {
    if (uiState.loading === false) {
      props.onClose();
    }
  }, [uiState.loading]);
  useEffect(() => {
    if (userState.message) {
      if (userState?.message) {
        toast({
          title: "Deactivation",
          description: userState?.message,
          status: "warning",
          duration: 2000,
          isClosable: true,
        });
      }
    }
  }, [userState.message]);
  return (
    <>
      <Modal
        blockScrollOnMount={true}
        closeOnOverlayClick={false}
        isOpen={props.isOpen}
        onClose={props.onClose}
        isCentered
        colorScheme="red"
        motionPreset="slideInBottom"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Deactivate Your Account</ModalHeader>
          <ModalBody>
            <Text fontWeight="bold" mb="1rem">
              Are you sure to deactivate your account?
            </Text>
            <UnorderedList>
              <ListItem>Your account will not be visible in public.</ListItem>
              <ListItem>All of your reviews will be hidden.</ListItem>
            </UnorderedList>
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
              id="DeactivateButton"
              isLoading={uiState.loading}
              loadingText={"Deactivating"}
              onClick={handleDeactivate}
            >
              Yes
            </Button>
            <Button
              colorScheme="red"
              _focus={{
                outline: "none",
                boxShadow: "none",
                textDecor: "none",
              }}
              onClick={props.onClose}
              id="CancelButton"
            >
              No
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
export default DeactivateAccountModal;
